import { SchemaProperty, UOMS } from '@amzn/awscat-portfolio-assessment-types';
import { Button, ButtonDropdown, ButtonDropdownProps, SpaceBetween } from '@amzn/awsui-components-react';
import * as React from 'react';
import { match, useHistory, useRouteMatch } from 'react-router';

import { constants } from '../../../common/Localization';
import { getCountText } from '../../../common/table/helper';
import { MatchParam } from '../../../common/types';
import { SchemaPropertyMap } from '../types';
import DeleteConfirmationModal from './BulkDeleteConfirmationModal';
import BulkEditComponent from './BulkEditComponent';
export interface PortfolioTableActionGroupProp {
    resourceType: string;
    resourceName: string;
    resourceCount: number;
    selectionCount: number;
    hasFilter: boolean;
    filteredCount: number;
    onConfirmDeletion: () => Promise<void>;
    onConfirmDeleteAll: () => Promise<void>;
    onConfirmBulkEdit: (
        selectAll: boolean,
        selectedHeader: string,
        updatedValue: string | number | boolean,
        updatedUOM?: UOMS,
    ) => Promise<void>;
    schemaProperties: SchemaProperty[];
    schemaPropertyMap: SchemaPropertyMap;
    loading?: boolean;
    attributeActions?: JSX.Element;
}

const PortfolioTableActionGroup = (props: PortfolioTableActionGroupProp): JSX.Element => {
    const portfolioMatch: match<MatchParam> | null = useRouteMatch({
        path: '/portfolio/:portfolioId',
    });
    const portfolioId = portfolioMatch?.params?.portfolioId;
    const [deleteModalVisible, setDeleteModalVisible] = React.useState(false);
    const [deleteAll, setDeleteAll] = React.useState(false);
    const [editModuleVisible, setEditModuleVisible] = React.useState(false);

    const history = useHistory();

    const countText = getCountText(props.selectionCount, props.filteredCount, props.resourceCount);
    const actionDropDownItems: ButtonDropdownProps.Item[] = [
        { id: 'import', text: constants.IMPORT_MORE_DATA_ACTION_BUTTON_TEXT },
        { id: 'deleteAll',
            text: `${constants.DELETE_BUTTON_TEXT} ${countText}`,
            disabled: !countText,
        },
    ];
    const actionDropDownOnClick = (e: CustomEvent<ButtonDropdownProps.ItemClickDetails>): void => {
        if (e.detail.id === 'deleteAll') {
            setDeleteAll(props.selectionCount === 0 && props.filteredCount === 0); // delete all if none are selected and filter is not set
            setDeleteModalVisible(true);
        } else if (e.detail.id === 'import') {
            history.push({
                pathname: `/portfolio/${portfolioId}/management/import-from-file`,
                state: {
                    fromType: props.resourceType,
                },
            });
        }
    };

    const bulkEditOnClick = (): void => {
        setEditModuleVisible(!editModuleVisible);
    };

    const actionsButtons = (
        <SpaceBetween direction="horizontal" size="xs">
            {props.attributeActions}
            <ButtonDropdown
                items={actionDropDownItems}
                onItemClick={actionDropDownOnClick}
            >
                {constants.ACTION_BUTTON_TEXT}
            </ButtonDropdown>
            <Button onClick={bulkEditOnClick}>{constants.EDIT_BUTTON_TEXT}</Button>
            <DeleteConfirmationModal
                resourceName={props.resourceName}
                countText={countText}
                visible={deleteModalVisible}
                setVisible={setDeleteModalVisible}
                confirmBulkDeletion={props.onConfirmDeletion}
                confirmDeleteAll={props.onConfirmDeleteAll}
                deleteAll={deleteAll}
            />
        </SpaceBetween>
    );
    const editModule = (
        editModuleVisible && (
            <BulkEditComponent
                resourceName={props.resourceName}
                countText={countText}
                selectAll={!props.selectionCount}
                setVisible={setEditModuleVisible}
                visible={editModuleVisible}
                onConfirmBulkEdit={props.onConfirmBulkEdit}
                schemaProperties={props.schemaProperties}
                schemaPropertyMap={props.schemaPropertyMap}
            />
        )
    );

    return (
        <SpaceBetween id={props.resourceType} direction="vertical" size="xs">
            {props.resourceCount ? actionsButtons : null}
            {editModule}
        </SpaceBetween>
    );
};

export default PortfolioTableActionGroup;
